package org.hs_soft.runmynesto.domain.model.menu

data class MenuHeaderModel(
    val appIcon:String,
    val title1:String,
    val title2:String,
)
